export default __webpack_public_path__ + "static/media/error-modal.66a603cf.svg";